import { StyleSheet } from 'react-native'

export const webBgStyles = StyleSheet.create({
  linearGradient: {
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'hidden',
    zIndex: -1
  },
  frame: {
    height: '100%',
    width: '100%',
    position: 'fixed',
    backgroundColor: '#7B043D',
    zIndex: 0,
    left: 0,
    top: 0
  },
  lastScreenImage: {
    width: '100%',
    height: '100%'
  }
})
